export default "/wind2.12337d74-2dd7f7.svg";